export const environment = {
  name: "Production",
  production: true,
  mapId: "e2926e5bfb22860c",
  keys: {
    firebaseConfig: {
      projectId: "parkour-base-project",
      appId: "1:294969617102:web:f9a2fcf843e8b288313e9f",
      databaseURL: "https://parkour-base-project.firebaseio.com",
      storageBucket: "parkour-base-project.appspot.com",
      locationId: "us-central1",
      authDomain: "parkour-base-project.firebaseapp.com",
      messagingSenderId: "294969617102",
      measurementId: "G-K7E4HFP8NM",
      apiKey: "AIzaSyB_Ttp8sb80ykt_OdgXdGk61cXzgfFCnZk",
    },
    typesense: {
      host: "g5re3ouiqm0j8bc9p-1.a1.typesense.net",
      apiKey: "7yxCDDLoGisH1vDtl2ZBfIglrr3OXsVk",
    },
  },
};
